
import { Component, inject, OnInit } from '@angular/core';
import { GenericStreamsService } from '../../../../../service/generic-streams.service';
import { MatDialogRef } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { KeyQuestion, StreamClosingType } from '../../../../../lib/interfaces/generic-streams';
import { AppdataService } from '../../../../../service/appdata.service';
import { AgentConfig } from '../../../../../lib/interfaces/aitypes';

@Component({
    selector: 'app-add-config',
    standalone: false,
    templateUrl: './add-config.component.html',
    styleUrl: './add-config.component.scss'
})
export class AddConfigComponent implements OnInit {
    streamService = inject(GenericStreamsService);
    dataService = inject(AppdataService);
    dialog = inject(MatDialogRef<AddConfigComponent>);
    fb = inject(FormBuilder);

    closingStreamTypes: StreamClosingType[] = [];
    newConfigForm: FormGroup = new FormGroup({});
    isLoading: boolean = false;
    agentList: AgentConfig[] = [];

    editKeyQuestionTitle: FormControl = new FormControl();
    editKeyQuestionQ: FormControl = new FormControl();
    keyQuestionDetailsEdit = "";

    editKeyQuestion = -1;


    ngOnInit(): void {
        this.dataService.agents.asObservable().subscribe(agents => {
            this.agentList = agents;
        });
        this.newConfigForm = this.fb.group({
            name: ["", Validators.required],
            description: ["", Validators.required],
            duration: [0],
            credits: [0],
            websearchStatus: [false],
            uploadStatus: [false],
            agentId: ["", Validators.required],
            agentPrompt: [""],
            closingPromptId: ["", Validators.required],
            keyQuestions: this.fb.array([], Validators.required),
            requiredStepIds: this.fb.array([]),
            stepGoal: [null]
        })
        this.closingStreamTypes = this.dataService.streamClosingTypes;
    }

    close() {
        this.dialog.close();
    }
    async save() {
        if (this.newConfigForm.valid === false) {
            return;
        }

        let result = await this.streamService.addGenericStepConfig(this.newConfigForm.value);
        if (result === false) return;

        let data = this.newConfigForm.value;
        data.websearch = {
            questions: [],
            researchPrompt: "",
            resultPrompt: "",
        }
        data.upload = {
            resultPrompt: "",
        }
        this.dialog.close(data);

    }
    get keyQuestions(): FormArray {
        return this.newConfigForm.get('keyQuestions') as FormArray;
    }
    addKeyQuestion(question: string, description: string, title: string) {
        const keyQuestionGroup = this.fb.group({
            title: [title, Validators.required],
            question: [question, Validators.required],
            description: [description, Validators.required]
        });
        (this.newConfigForm?.get('keyQuestions') as FormArray)?.push(keyQuestionGroup);
    }
    removeKeyQuestion(index: number) {
        (this.newConfigForm?.get('keyQuestions') as FormArray)?.removeAt(index);
    }

    changeQuestionOrder(previousIndex: number, currentIndex: number): void {
        const keyQuestions = this.newConfigForm?.get('keyQuestions') as FormArray;
        if (keyQuestions) {
            this.editKeyQuestion = -1;
            const question = keyQuestions.at(previousIndex);
            keyQuestions.removeAt(previousIndex);
            keyQuestions.insert(currentIndex, question);
        }
    }

    toggleKeyQuestionEdit(i: number) {
        if (this.editKeyQuestion !== i) {
            this.editKeyQuestion = i;
            this.editKeyQuestionTitle?.setValue(this.keyQuestions.controls[i].get('title')?.value);
            this.editKeyQuestionQ?.setValue(this.keyQuestions.controls[i].get('question')?.value);
        } else {
            this.editKeyQuestion = -1;
        }
    }
    saveKeyQuestionEdit(i: number) {

        this.keyQuestions.controls[i].get('title')!.setValue(this.editKeyQuestionTitle.value);
        this.keyQuestions.controls[i].get('question')!.setValue(this.editKeyQuestionQ.value);
        this.keyQuestions.controls[i].get('description')!.setValue(this.keyQuestionDetailsEdit);
        this.toggleKeyQuestionEdit(i);

    }

    onKeyQuestionDetailsChange($event: any) {
        if (typeof $event == "string") {
            this.keyQuestionDetailsEdit = $event;
        }
    }

    get titleControl(): FormControl {
        return this.keyQuestions.controls[this.editKeyQuestion].get('title') as FormControl;
    }
    get questionControl(): FormControl {
        return this.keyQuestions.controls[this.editKeyQuestion].get('question') as FormControl;
    }
}
